import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import FileAttach from "../../../../../../images/Attachments.svg";
import Input from "../../../../../../stories/Input/Input";
import { useLazyQuery, useMutation } from "@apollo/client";
import { Junction } from "../../../masters/subsidary/junctions/queries/types";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import {
  AtsTicketsByNodeForStatus,
  GetItemsDetails,
  GetTicketDetailsForFollowUp,
  JunctionsNode,
} from "../../../masters/items/queries/queries";
import PoleNumComponent from "../../../../../common/Autocomplete/PoleNumComponent";
import {
  debouncedDelay,
  DEFAULT_TIME,
  emptyFunc,
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  TicketStatus,
} from "../../../../../../utils/constants";
import { ResolveTypes } from "../../../maps/ticketing/history/AddFollowUpStatus";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { Button } from "../../../../../../stories/Button/Button";
import {
  AddTicketDetailsResult,
  AddTicketDetailsVariables,
  AtsStckItemDetailsEdges,
  AtsStckItemDetailsOrderField,
  DeviceTypes,
  GetItemsDetailsResult,
  GetItemsDetailsVars,
  ItemDetailsQueryType,
  TicketAssetsInput,
} from "../../../masters/items/queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { Checkbox } from "@mui/material";
import Info from "../../../../../../images/Info.svg";
import documentImage from "../../../../../../images/DownloadImage.svg";
import { CustomDrawer } from "../../../../../../styles/CustomDrawerStyles";
import { AppContext } from "../../../../../../context/context";
import { payloadTypes } from "../../../../../../context/reducer";
import ViewAssetDetails from "../../../maps/ticketing/raisedtickets/ViewAssetDetails";
import {
  Operation,
  PageFor,
  empType,
} from "../../../../../../utils/Enum.types";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import useToken from "../../../../../../customHooks/useToken";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { AddTicketDetails } from "../../../masters/items/queries/mutations";
import { handleUploadAndDownloadFile } from "../../../../../../utils/Upload";
import { AtsTicketDetails } from "../../../maps/queries/types";
import { MapsContext } from "../../../maps/context/context";
import {
  CustomModal,
  toInputStandardDate,
} from "../../../../../../utils/UtilFunctions";
import { ImageModalStylesInTickets } from "../../../../../../styles/CustomModalStyles";
import DownloadImage from "../../../../../../images/DownloadImage.svg";
import {
  ticketDataByNodeId,
  ticketDetailsByNodeId,
} from "../../../maps/queries/queriers";
import { getDownloadUrl } from "../../../../../../utils/DownloadFile";
import { GetTickets } from "../../../../../../queries/queries";
import {
  AtsTicketsOrderField,
  TicketsQueryType,
} from "../../../../../../queries/types";
import { GetDashboardJunctionCount, GetDashboardTicketCount } from "../queries";
import DeviceTypesSelect from "../../../../../../customComponents/DeviceTypesSelect";
import { Label } from "../../../../../../stories/Label/Label";
import { useDebounce } from "../../../../../../customHooks/useDebounce";
import ReplaceStock from "./ReplaceStock";
import { AtsTickets } from "../../../../mobileapp/queries/types";

interface Props {
  setDrawerFlag: React.Dispatch<React.SetStateAction<ResolveTypes>>;
  vendorId: number;
  junctionId: number;
  ticketId: number;
  pageType: PageFor;
  companyId: number;
  includeDeviceType?: boolean;
}

export interface itemDataType {
  id: number;
  img: string;
  desc: string;
  slNo: number;
  prodSerialNo: string;
  poleNum: number;
  prodBatchNo: string;
  prodWarrantyStartDate: string;
  prodWarrantyEndDate: string;
  maintainedBy: string;
  siteLocation: string;
  prodInstallationEndDate: string;
}

export interface selectedItemsType extends TicketAssetsInput {
  file: File[];
}

export const intialItemData: itemDataType = {
  id: 0,
  img: "",
  desc: "",
  slNo: 0,
  prodSerialNo: "",
  poleNum: 0,
  maintainedBy: "",
  prodBatchNo: "",
  prodInstallationEndDate: "",
  prodWarrantyEndDate: "",
  prodWarrantyStartDate: "",
  siteLocation: "",
};
const ResolveDetails = ({
  setDrawerFlag,
  vendorId,
  junctionId,
  ticketId,
  pageType,
  companyId,
  includeDeviceType,
}: Props) => {
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const { handleToken } = useToken();
  const { state, dispatch } = useContext(AppContext);
  const { serverDate } = useServerDateandTime();
  const [poleNum, setPoleNum] = useState<number | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [itemDetails, setItemDetails] = useState<AtsStckItemDetailsEdges[]>([]);
  const [deviceTypes, setDeviceTypes] = useState<DeviceTypes[]>([]);
  const [deviceType, setDeviceType] = useState<DeviceTypes>({
    deviceTypeID: 0,
    deviceName: "",
    numOfUnits: 0,
  });

  const [remark, setRemark] = useState("");
  const [message, setMessage] = useState(emptyMessage);
  const { state: mapsContext } = useContext(MapsContext);
  const [openModal, setOpenModal] = useState(false);

  const [previewImage, setPreviewImage] = useState("");

  const [imageModal, setImageModal] = useState(false);

  const [progress, setProgress] = useState(0);

  const value = useRef("");

  const [file, setFiles] = useState<File[]>([]);
  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const [assetDetailsModal, setAssetDetailsModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState<selectedItemsType[]>([]);
  const [newSerialNumber, setNewSerialNumber] = useState("");
  const [itemData, setItemData] = useState<itemDataType>(intialItemData);

  const [GetTicktNode, { data: ticketNode }] = useLazyQuery<
    { node: AtsTicketDetails },
    nodeVar
  >(ticketDetailsByNodeId);

  const [GetTicktDataNode, { data: ticketDataNode }] = useLazyQuery<
    { node: AtsTickets },
    nodeVar
  >(ticketDataByNodeId);

  const [getJunctionByNode, { data: junctionData }] = useLazyQuery<
    { node: Junction },
    nodeVar
  >(JunctionsNode);

  useEffect(() => {
    if (junctionId) {
      getJunctionByNode({
        variables: {
          id: junctionId,
        },
      });
    }
  }, [getJunctionByNode, junctionId]);

  const [GetJunctionItems, { data, fetchMore, loading }] = useLazyQuery<
    GetItemsDetailsResult,
    GetItemsDetailsVars
  >(GetItemsDetails);
  useEffect(() => {
    if (customer_id && pageType === PageFor.GENERAL) {
      GetJunctionItems({
        variables: {
          customerID: customer_id ? customer_id : 0,
          companyID: 0,
          subsidiaryID: 0,
          junctionID: junctionId,
          siteID: 0,
          input: {
            query_type: ItemDetailsQueryType.ALL,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckUomID: 0,
            stckSubCategoryID: 0,
            itemID: 0,
            ldgrID: vendorId,
            poleNum,
            empID: user_details.id,
          },
          after: null,
          first: ROWS_PER_PAGE,
          name: debouncedSearch,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsStckItemDetailsOrderField.CREATED_AT,
          },
        },
      });
    }
  }, [
    customer_id,
    GetJunctionItems,
    poleNum,
    junctionId,
    vendorId,
    debouncedSearch,
    pageType,
    user_details.id,
  ]);

  useEffect(() => {
    if (mapsContext.ticketDetailsId) {
      GetTicktNode({
        variables: {
          id: mapsContext.ticketDetailsId,
        },
      }).then(async ({ data }) => {
        if (data && data.node) {
          setRemark(data.node.remarks);
        }
      });
    }
  }, [GetTicktNode, mapsContext.ticketDetailsId]);

  useEffect(() => {
    if (mapsContext.ticketId)
      GetTicktDataNode({
        variables: {
          id: Number(mapsContext.ticketId),
        },
      });
  }, [mapsContext.ticketId, GetTicktDataNode]);

  const [addTicket] = useMutation<
    AddTicketDetailsResult,
    AddTicketDetailsVariables
  >(AddTicketDetails, {
    onError: (e) =>
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      }),
  });

  const hanldeMainImagePreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const newFiles = Array.from(e.target.files);
      setFiles((prev) => [...prev, ...newFiles]);
    }
    e.target.value = "";
  };
  const handleImagePreview = (
    e: React.ChangeEvent<HTMLInputElement>,
    itemId: number
  ) => {
    if (e.target.files && e.target.files.length > 0) {
      const newFiles = Array.from(e.target.files);

      setSelectedItems((prev) => {
        const filtered = prev.filter((f) => f.itemDetailsID !== itemId);

        const newData: selectedItemsType = {
          file: newFiles,
          anyChanges: "",
          AnySparesChanged: "",
          itemDetailsID: itemId,
          remarks: remark,
          imagesPath: "",
        };
        return [...filtered, newData];
      });
    }
    e.target.value = "";
  };

  const handleSubmit = async () => {
    try {
      const token = await handleToken();

      const itemsWithoutFiles = selectedItems.filter((si) => si.file);

      // if (file === null && itemsWithoutFiles.length === 0) {
      //   setMessage({
      //     flag: true,
      //     message: "Attachment is required",
      //     operation: Operation.NONE,
      //   });
      //   return;
      // } else {

      const filename = file.length
        ? file
            .map((item, index) => {
              return `${companyId}/ticketDetails/${item.name}`;
            })
            .join(";")
        : "";

      // if (selectedItems.length) {
      if (token && customer_id) {
        const assetDetails: TicketAssetsInput[] = selectedItems.flatMap(
          (si) => {
            let filename = si.file.length
              ? si.file
                  .map((file, index) => {
                    return `${companyId}/ticketDetails/itemDetails/${file.name}`;
                  })
                  .join(";")
              : "";
            return [
              {
                itemDetailsID: si.itemDetailsID,
                anyChanges: si.anyChanges,
                AnySparesChanged: si.AnySparesChanged,
                remarks: si.remarks,
                imagesPath: filename,
              },
            ];
          }
        );

        addTicket({
          variables: {
            token,
            todaysDate: serverDate,
            customerID: customer_id,
            ticketID: ticketId,
            user_details,
            deviceTypes: deviceTypes
              ? deviceTypes.map((item) => ({
                  deviceTypeID: item.deviceTypeID,
                  numOfUnits: item.numOfUnits,
                }))
              : [],
            input: {
              status: TicketStatus.RESOLVED,
              remarks: remark,
              imagesPath: file ? filename : "",
              assignedID: 0,
            },
            assetDetails,
          },
          refetchQueries: [
            {
              query: AtsTicketsByNodeForStatus,
              variables: {
                customerID: customer_id ? customer_id : 0,
                empID: user_details.id ? user_details.id : 0,
              },
            },
            {
              query: GetDashboardJunctionCount,
              variables: {
                customerID: customer_id ? customer_id : 0,
                empID: user_details.id ? user_details.id : 0,
              },
            },
            {
              query: AtsTicketsByNodeForStatus,
              variables: {
                id: mapsContext.ticketId,
              },
            },
            {
              query: GetTicketDetailsForFollowUp,
              variables: {
                customerID: customer_id!,
                ticketID: ticketId,
              },
            },
            {
              query: GetTickets,
              variables: {
                after: null,
                first: ROWS_PER_PAGE,
                name: debouncedSearch,
                deviceTypes: [],
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsTicketsOrderField.TICKET_NO,
                },
                companyID: 0,
                customerID: customer_id,
                subsidiaryID: 0,
                junctionID: 0,
                reason: "",
                startDate: undefined,
                endDate: undefined,
                input: {
                  itemID: 0,
                  ldgrID: 0,
                  stckCategoryID: 0,
                  stckGroupID: 0,
                  stckManufacturerID: 0,
                  stckSubCategoryID: 0,
                  stckUomID: 0,
                  query_type: TicketsQueryType.ALL,
                  itemDetailsID: 0,
                  status: [TicketStatus.RESOLVED],
                  priority: [],
                  empID: user_details.id!,
                },
                siteID: 0,
              },
            },
            {
              query: GetDashboardTicketCount,
              variables: {
                customerID: customer_id ? customer_id : 0,
                empID: user_details.id ? user_details.id : 0,
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.AddTicketDetails) {
            const files = file;

            const uploadFilePromise = Promise.all([
              ...selectedItems.map((f, index) => {
                for (let i = 0; i < f.file.length; i++) {
                  const fileExt = f.file[i]?.name.split(".").pop();
                  handleUploadAndDownloadFile(
                    f.file[i]!,
                    `${companyId}/ticketDetails/${data.AddTicketDetails.id}/itemDetails/${f.itemDetailsID}_${i}.${fileExt}`,
                    setProgress,
                    false
                  );
                }
              }),
              file.forEach((f, i) => {
                const fileExt = f?.name.split(".").pop();
                handleUploadAndDownloadFile(
                  f!,
                  `${companyId}/ticketDetails/${data.AddTicketDetails.id}_${i}.${fileExt}`,
                  setProgress,
                  false
                );
              }),
            ]);
            Promise.all([uploadFilePromise]).then(([sendMsgData]) => {
              if (sendMsgData) {
                setFiles([]);
                setMessage({
                  flag: true,
                  message: "Added successfully",
                  operation: Operation.CREATE,
                });
              }
            });

            setSelectedItems([]);
          }
        });
      }
      // }
      //   else {
      //     setMessage({
      //       flag: true,
      //       message: `${ledgerLabel} is missing`,
      //       operation: Operation.NONE,
      //     });
      //   }
      // }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  useEffect(() => {
    setRemark("");
    setFiles([]);
    setItemDetails([]);
  }, []);

  const handleCheckboxChange = (item: {
    id: number;
    remarks: string;
    imagesPath?: string;
    anyChanges: string;
    anySparesChanged: string;
  }) => {
    setSelectedItems((prev) => {
      const exists = prev.find((i) => i.itemDetailsID === item.id);
      if (exists) {
        return prev.filter((i) => i.itemDetailsID !== item.id);
      } else {
        return [
          ...prev,
          {
            itemDetailsID: item.id,
            anyChanges: item.anyChanges,
            AnySparesChanged: item.anySparesChanged,
            remarks: item.remarks || "",
            imagesPath: item.imagesPath || "",
            file: [], // ← Start with empty array
          },
        ];
      }
    });
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      setDrawerFlag({
        flag: false,
        junctionId: 0,
        vendorId: 0,
      });
    }
  };

  const handleScroll = () => {
    if (hasNextPage && !loading) {
      fetchMore({
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: (prevResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prevResult;

          const newEdges = fetchMoreResult.GetItemsDetails.edges;
          const pageInfo = fetchMoreResult.GetItemsDetails.pageInfo;

          setEndCursor(pageInfo.endCursor);
          setHasNextPage(pageInfo.hasNextPage);

          const duplicateCheck = prevResult.GetItemsDetails
            ? prevResult.GetItemsDetails.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              )
            : [];

          if (duplicateCheck.length > 0) return prevResult;

          return {
            GetItemsDetails: {
              edges: [...itemDetails, ...newEdges],
              pageInfo,
              totalCount: data ? data.GetItemsDetails.totalCount! : 0,
            },
          };
        },
      });
    }
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetItemsDetails.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCustomer) => {
          const filteredStudent = itemDetails.find(
            (ticket) => ticket.node.id === newCustomer.node.id
          );
          if (filteredStudent) {
            return {
              ...newCustomer,
              node: {
                ...newCustomer.node,
              },
            };
          }
          return newCustomer;
        });

        setItemDetails(updatedNewData);
      } else {
        setItemDetails(newData);
      }

      setEndCursor(data.GetItemsDetails.pageInfo.endCursor);
      setHasNextPage(data.GetItemsDetails.pageInfo.hasNextPage);
    } // eslint-disable-next-line
  }, [loading, data]);

  const disableSubmit = useMemo(() => {
    return (
      remark === "" ||
      selectedItems.filter((itm) => itm.remarks === "").length > 0
    );
  }, [selectedItems, remark]);

  const handleDeviceTypeChange = () => {
    if (!deviceType.deviceTypeID) return;

    setDeviceTypes((prev) => {
      const existingIndex = prev.findIndex(
        (d) => d.deviceTypeID === deviceType.deviceTypeID
      );

      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          numOfUnits: deviceType.numOfUnits,
        };
        return updated;
      } else {
        return [...prev, deviceType];
      }
    });

    setDeviceType({ deviceTypeID: 0, deviceName: "", numOfUnits: 0 });
  };

  return (
    <div className="resolve-details">
      <div className="resolve-details__title">
        <Title>Resolve Details</Title>
        <img
          src={Close}
          alt=""
          onClick={() =>
            setDrawerFlag({
              flag: false,
              vendorId: 0,
              junctionId: 0,
            })
          }
        />
      </div>
      <div className="resolve-details__input">
        <label className="resolve-details__input--user-input">
          <input
            type="text"
            placeholder="Type here..."
            id="file-name-display"
            autoFocus
            onChange={(e) => {
              value.current = e.target.value;
              setRemark(e.target.value);
            }}
            value={remark}
            disabled={pageType === PageFor.VIEW}
          />

          <img
            src={FileAttach}
            alt="Attach file"
            className="browse-icon"
            onClick={() => {
              const inputFile = document.getElementById("student-documents");

              if (inputFile) {
                inputFile?.click();
              }
            }}
          />

          <input
            id="student-documents"
            type="file"
            className="resolve-details__input--choose-file"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              hanldeMainImagePreview(e);
            }}
            disabled={pageType === PageFor.VIEW}
            accept="image/jpg, image/png, image/jpeg"
            multiple
          />
        </label>
      </div>

      {file.length
        ? file.map((item, index) => {
            const previewUrl = URL.createObjectURL(item);

            return (
              <div className="resolve-details__ul--comments--img" key={index}>
                <div
                  key={index}
                  className="resolve-details__ul--comments--img-item"
                >
                  <div className="resolve-details__ul--comments--images--item">
                    <img
                      src={previewUrl}
                      alt={`Attached ${index + 1}`}
                      className="preview-thumbnail"
                      onClick={() => {
                        setPreviewImage(previewUrl);
                        setImageModal(true);
                      }}
                    />

                    <img
                      src={Close}
                      alt="Remove"
                      onClick={() => {
                        setFiles((prevFiles) =>
                          prevFiles.filter((_, i) => i !== index)
                        );
                      }}
                    />
                  </div>

                  <span className="image-filename">{item.name}</span>
                </div>
              </div>
            );
          })
        : null}

      {ticketNode && ticketNode.node.imagesPath ? (
        <div className="resolve-details__ul--comments--images">
          {ticketNode.node.imagesPath
            .split(";")
            .filter(Boolean)
            .map((path, index) => {
              const imageName = path.split("/").pop() || `Image ${index + 1}`;

              const parts = path.split("/");
              const fileNameWithExt = parts.pop() || "";
              const ext = fileNameWithExt.split(".").pop() || "jpg";

              const fullS3Path = `${ticketNode.node.companyID}/ticketDetails/${ticketNode.node.id}_${index}.${ext}`;

              return (
                <div
                  key={index}
                  className="resolve-details__ul--comments--images"
                >
                  <div className="image-wrapper">
                    <img
                      src={documentImage} // Placeholder thumbnail
                      alt={imageName}
                      className="preview-thumbnail"
                      onClick={async () => {
                        try {
                          const downloadUrl = await getDownloadUrl(
                            fullS3Path,
                            false
                          );
                          setPreviewImage(downloadUrl);
                          setImageModal(true);
                        } catch (err) {
                          console.error("Failed to get download URL:", err);
                          setMessage({
                            flag: true,
                            message: "Failed to load image",
                            operation: Operation.NONE,
                          });
                        }
                      }}
                    />
                  </div>
                  <span className="image-filename">{imageName}</span>
                </div>
              );
            })}
        </div>
      ) : null}

      <div
        className={
          includeDeviceType
            ? "resolve-details__filter row g-0"
            : "resolve-details__filters row g-0"
        }
      >
        <div className="col">
          <Input
            id="data_search"
            placeholder="Search..."
            onChange={(e) => {
              setSearchData(e.target.value);
            }}
          />{" "}
        </div>
        <div className="col-4">
          {junctionData && junctionData.node.poles > 0 ? (
            <PoleNumComponent
              onChange={(newValue) => {
                setPoleNum(newValue);
              }}
              onKeyDown={emptyFunc}
              value={poleNum}
              label="Pole Number"
              poleNum={junctionData ? junctionData.node.poles : 0}
            />
          ) : null}
        </div>
        {includeDeviceType && (
          <>
            <div className="resolve-details__filter--grid">
              <Label>Device Types Select</Label>{" "}
              <DeviceTypesSelect
                label=""
                onChange={(newValue) => {
                  if (newValue) {
                    setDeviceType({
                      ...deviceType,
                      deviceTypeID: newValue.value,
                      deviceName: newValue.label,
                    });
                  }
                }}
                onKeyDown={() => {}}
                value={deviceType.deviceTypeID}
              />
              <Label>Number Of Units</Label>
              <Input
                placeholder="Number Of Units"
                type="number"
                value={deviceType.numOfUnits}
                onChange={(e) => {
                  setDeviceType({
                    ...deviceType,
                    numOfUnits: Number(e.target.value),
                  });
                }}
              />
            </div>
            <Button
              onClick={() => {
                handleDeviceTypeChange();
              }}
            >
              +
            </Button>
              <ul className="list-disc ml-5">
                {deviceTypes.map((d, index) => (
                  <li key={index}>
                    <div className="resolve-details__ul--device-type">
                      <div className="resolve-details__ul--device-type--list">
                        <div className="resolve-details__ul--device-type--flex">
                        <Label>Device Type :</Label>
                        <span>{d.deviceName}</span>
                        </div>
                        <div className="resolve-details__ul--device-type--flex">
                        <Label>Units :</Label>
                        <span>{d.numOfUnits}</span>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
          </>
        )}
       
      </div>

      <div
        className={
          includeDeviceType
            ? `resolve-details__ul${file ? "--file" : ""}`
            : `resolve-details__no-type${file ? "--file" : ""}`
        }
        onScroll={handleScroll}
      >
        {pageType === PageFor.GENERAL && data
          ? itemDetails.map((res, index) => {
              const img = require(`../../../../../../images/ItemIcons/${
                res.node.item.icon ? res.node.item.icon : "item"
              }.svg`);
              const isChecked = selectedItems.some(
                (item) => item.itemDetailsID === res.node.id
              );
              return (
                <li key={index}>
                  <div className="resolve-details__ul--li">
                    <div className="resolve-details__ul--flex">
                      {pageType === PageFor.GENERAL && (
                        <Checkbox
                          checked={isChecked}
                          onChange={() =>
                            handleCheckboxChange({
                              id: res.node.id,
                              remarks: "",
                              anyChanges: "",
                              anySparesChanged: "",
                              // imagesPath: file || file[0] || "",
                            })
                          }
                        />
                      )}

                      <img src={img} alt="" />
                      <div>
                        <b>{res.node.item.desc}</b>
                        <div className="resolve-details__ul--block">
                          <b className="font-blue">{res.node.item.slNo}</b>
                          <span className="font-grey">
                            {" "}
                            Pole {res.node.poleNum}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="resolve-details__ul--flex">
                      {(state.empSubType === empType.VENDOR_MANAGER ||
                        state.empSubType === empType.TECHNICIAN) &&
                        isChecked && (
                          <Button
                            mode="replace"
                            onClick={() => {
                              setItemData({
                                id: res.node.id,
                                img,
                                desc: res.node.item.desc,
                                slNo: res.node.item.slNo,
                                prodSerialNo: res.node.prodSerialNo,
                                poleNum: res.node.poleNum,
                                prodBatchNo: res.node.prodBatchNo,
                                prodWarrantyStartDate: toInputStandardDate(
                                  res.node.prodWarrantyStartDate
                                ),
                                prodWarrantyEndDate: toInputStandardDate(
                                  res.node.prodWarrantyEndDate
                                ),
                                maintainedBy: res.node.vendorDetails.desc,
                                siteLocation: `${res.node.prodLatitude}, ${res.node.prodLongitude}`,
                                prodInstallationEndDate:
                                  toInputStandardDate(
                                    res.node.prodInstallationEndDate
                                  ) !== DEFAULT_TIME
                                    ? toInputStandardDate(
                                        res.node.prodInstallationEndDate
                                      )
                                    : "-",
                              });
                              setOpenModal(true);
                            }}
                          />
                        )}
                      <img
                        src={Info}
                        alt=""
                        onClick={() => {
                          dispatch({
                            type: payloadTypes.SET_ITEM_DETAILS_ID,
                            payload: {
                              itemDetailsId: res.node.id,
                            },
                          });
                          setAssetDetailsModal(!assetDetailsModal);
                        }}
                      />
                    </div>
                  </div>
                  {isChecked && (
                    <div className="resolve-details__ul--comments">
                      <label className="resolve-details__input--user-input">
                        <input
                          type="text"
                          placeholder="Type here..."
                          id="file-name-display"
                          autoFocus
                          onChange={(e) => {
                            const updatedItems = selectedItems.map((si) =>
                              si.itemDetailsID === res.node.id
                                ? { ...si, remarks: e.target.value }
                                : si
                            );
                            setSelectedItems(updatedItems);
                          }}
                          value={
                            selectedItems.find(
                              (si) => si.itemDetailsID === res.node.id
                            )?.remarks || ""
                          }
                        />

                        <img
                          src={FileAttach}
                          alt="Attach file"
                          className="browse-icon"
                          onClick={() => {
                            const inputFile = document.getElementById(
                              `student-documents__browse--inputTag_${res.node.id}`
                            );
                            if (inputFile) {
                              inputFile.click();
                            }
                          }}
                        />
                        <input
                          id={`student-documents__browse--inputTag_${res.node.id}`}
                          type="file"
                          className="resolve-details__input--choose-file"
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            handleImagePreview(e, res.node.id);
                          }}
                          accept="image/jpg, image/png, image/jpeg"
                          multiple
                        />
                      </label>

                      {selectedItems.find(
                        (f) => f.itemDetailsID === res.node.id
                      ) && (
                        <div className="resolve-details__ul--comments--images">
                          {selectedItems
                            .find((f) => f.itemDetailsID === res.node.id)
                            ?.file.map((file, index) => {
                              const previewUrl = URL.createObjectURL(file);

                              return (
                                <div
                                  key={index}
                                  className="resolve-details__ul--comments--img-item"
                                >
                                  <div className="resolve-details__ul--comments--images--item">
                                    <img
                                      src={previewUrl}
                                      alt={`Attached ${index + 1}`}
                                      className="preview-thumbnail"
                                      onClick={() => {
                                        setPreviewImage(previewUrl);
                                        setImageModal(true);
                                      }}
                                    />
                                    {/* <span>
                                      {selectedItems.find(
                                        (f) => f.itemDetailsID === res.node.id
                                      )?.file[0]?.name || ""}
                                    </span> */}

                                    <img
                                      src={Close}
                                      alt="Remove"
                                      onClick={() => {
                                        setSelectedItems(
                                          (prev) =>
                                            prev
                                              .map((item) => {
                                                if (
                                                  item.itemDetailsID ===
                                                  res.node.id
                                                ) {
                                                  const updatedFiles =
                                                    item.file.filter(
                                                      (_, i) => i !== index
                                                    );
                                                  return {
                                                    ...item,
                                                    file: updatedFiles,
                                                  };
                                                }
                                                return item;
                                              })
                                              .filter(
                                                (item) => item.file.length > 0
                                              ) // Remove item if no images left
                                        );
                                      }}
                                    />
                                  </div>

                                  <span className="image-filename">
                                    {file.name}
                                  </span>
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  )}
                </li>
              );
            })
          : pageType === PageFor.VIEW &&
            ticketNode &&
            ticketNode.node.ticketAssetDetails
          ? ticketNode.node.ticketAssetDetails.map((res, index) => {
              const img = require(`../../../../../../images/ItemIcons/${
                res.itemDetails.item.icon ? res.itemDetails.item.icon : "item"
              }.svg`);
              const imageName = `${res.images_path.split("/").pop()}`;

              return (
                <li key={index}>
                  <div className="resolve-details__ul--li">
                    <div className="resolve-details__ul--flex">
                      <img src={img} alt="" />
                      <div>
                        <b>{res.itemDetails.item.desc}</b>
                        <div className="resolve-details__ul--block">
                          <b className="font-blue">
                            {res.itemDetails.item.slNo}
                          </b>
                          <span className="font-grey">
                            {" "}
                            Pole {res.itemDetails.poleNum}
                          </span>
                        </div>
                      </div>
                    </div>
                    <img
                      src={Info}
                      alt=""
                      onClick={() => {
                        dispatch({
                          type: payloadTypes.SET_ITEM_DETAILS_ID,
                          payload: {
                            itemDetailsId: res.itemDetails.id,
                          },
                        });
                        setAssetDetailsModal(!assetDetailsModal);
                      }}
                    />
                  </div>
                  <div className="resolve-details__ul--comments">
                    <label className="resolve-details__input--user-input">
                      {res.remarks}
                      <img
                        src={FileAttach}
                        alt="Attach file"
                        className="browse-icon"
                        onClick={() => {
                          const inputFile = document.getElementById(
                            `student-documents__browse--inputTag_${res.itemDetails.id}`
                          );
                          if (inputFile) {
                            inputFile.click();
                          }
                        }}
                      />
                      <input
                        id={`student-documents__browse--inputTag_${res.itemDetails.id}`}
                        // type="file"
                        className="resolve-details__input--choose-file"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleImagePreview(e, res.itemDetails.id);
                        }}
                        // accept="image/jpg, image/png, image/jpeg"
                      />
                    </label>

                    {/* {res.images_path ? (
                      <div className="resolve-details__ul--comments--img">

                        <img
                          src={documentImage}
                          alt=""
                          onClick={async () => {                     
                            const ext = res.images_path.split(".").pop();
                            const filename = `${ticketNode.node.companyID}/ticketDetails/${ticketNode.node.id}/itemDetails/${res.itemDetails.id}_0.${ext}`;
                            const ers = await getDownloadUrl(filename, false);
                            setPreviewImage(ers);
                            setImageModal(!imageModal);
                          }}
                        />
                        <span>{imageName}</span>
                      </div>
                    ) : null} */}

                    {res.images_path ? (
                      <div className="resolve-details__ul--comments--img">
                        {res.images_path
                          .split(";")
                          .filter(Boolean)
                          .map((path, index) => {
                            const imageName =
                              path.split("/").pop() || `Image ${index + 1}`;

                            const parts = path.split("/");
                            const fileNameWithExt = parts.pop() || "";
                            const ext =
                              fileNameWithExt.split(".").pop() || "jpg";
                            const baseNameWithIndex = fileNameWithExt.replace(
                              `.${ext}`,
                              ""
                            );

                            const fullS3Path = `${ticketNode.node.companyID}/ticketDetails/${ticketNode.node.id}/itemDetails/${res.itemDetails.id}_${index}.${ext}`;

                            return (
                              <div
                                key={index}
                                className="resolve-details__ul--comments--img"
                              >
                                <div className="image-wrapper">
                                  <img
                                    src={documentImage} // Placeholder thumbnail
                                    alt={imageName}
                                    className="preview-thumbnail"
                                    onClick={async () => {
                                      try {
                                        const downloadUrl =
                                          await getDownloadUrl(
                                            fullS3Path,
                                            false
                                          );
                                        setPreviewImage(downloadUrl);
                                        setImageModal(true);
                                      } catch (err) {
                                        console.error(
                                          "Failed to get download URL:",
                                          err
                                        );
                                        setMessage({
                                          flag: true,
                                          message: "Failed to load image",
                                          operation: Operation.NONE,
                                        });
                                      }
                                    }}
                                  />
                                </div>
                                <span className="image-filename">
                                  {imageName}
                                </span>
                              </div>
                            );
                          })}
                      </div>
                    ) : null}
                  </div>
                </li>
              );
            })
          : null}

          {ticketDataNode &&
            ticketDataNode.node &&
            ticketDataNode.node.deviceTypes[0].deviceType !== "" && (
              <ul className="list-disc ml-5">
                {ticketDataNode.node.deviceTypes.map((d, index) => (
                  <li key={index}>
                    <div className="resolve-details__ul--device-type">
                      <div className="resolve-details__ul--device-type--list">
                        <div className="resolve-details__ul--device-type--flex">
                        <Label>Device Type :</Label>
                        <span>{d.deviceType}</span>
                        </div>
                        <div className="resolve-details__ul--device-type--flex">
                        <Label>Units :</Label>
                        <span>{d.numOfUnits}</span>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            )}
      </div>
      <div className="row g-0">
        <div className="col-8">
          {pageType === PageFor.GENERAL && (
            <Button
              mode="save"
              onClick={handleSubmit}
              disabled={disableSubmit}
            />
          )}

          <Button
            mode="cancel"
            onClick={() =>
              setDrawerFlag({
                flag: false,
                vendorId: 0,
                junctionId: 0,
              })
            }
          />
        </div>
        <div className="col flex-end">
          <div className="overall-total-count">
            Total Assets <b>{data ? data.GetItemsDetails.totalCount : 0}</b>
          </div>
        </div>
      </div>

      <CustomDrawer
        anchor="right"
        open={assetDetailsModal}
        onClose={() => setAssetDetailsModal(!assetDetailsModal)}
      >
        <ViewAssetDetails
          setModalFlag={setAssetDetailsModal}
          itemId={state.itemDetailsId}
          itemRetireId={0}
        />
      </CustomDrawer>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <CustomModal
        isOpen={imageModal}
        onRequestClose={() => setImageModal(!imageModal)}
        contentComponent={
          <>
            <div className="edit-vendor-response__title">
              <Title>Image details</Title>
              <img
                src={Close}
                alt=""
                onClick={() => setImageModal(!imageModal)}
              />
            </div>
            {previewImage && (
              <div
                className={`junc-follow-up__data--remarks--flex--image-container ${
                  previewImage ? "open" : ""
                }`}
              >
                <img
                  className="junc-follow-up__data--remarks--flex--image"
                  src={previewImage}
                  alt=""
                />
              </div>
            )}
          </>
        }
        style={ImageModalStylesInTickets}
      />

      <CustomModal
        isOpen={openModal}
        onRequestClose={() => setOpenModal(false)}
        contentComponent={
          <ReplaceStock
            setOpenModal={setOpenModal}
            itemData={itemData}
            ticketId={ticketId}
          />
        }
        style={ImageModalStylesInTickets}
      />
    </div>
  );
};

export default ResolveDetails;
